/**
 * Pinned "pseudo-projects" that always appear at the top of every
 * job/location dropdown (clock-in, hours grid, expenses). They're not real
 * project rows in the DB — just accounting labels. Hours billed to them are
 * hourly overhead and surface as the Office / Estimating payroll locations.
 */
export const PINNED_PROJECTS = [
  { project_id: "__office__", name: "Office" },
  { project_id: "__estimating__", name: "Estimating" },
];

export const PINNED_IDS = PINNED_PROJECTS.map((p) => p.project_id);
